// import A2 from './audio/Marimba.rubber.ff.A2.stereo.mp3';
import A3 from './audio/Marimba.rubber.ff.A3.stereo.mp3';
import A4 from './audio/Marimba.rubber.ff.A4.stereo.mp3';
import A5 from './audio/Marimba.rubber.ff.A5.stereo.mp3';
import A6 from './audio/Marimba.rubber.ff.A6.stereo.mp3';

// import Ab2 from './audio/Marimba.rubber.ff.Ab2.stereo.mp3';
import Ab3 from './audio/Marimba.rubber.ff.Ab3.stereo.mp3';
import Ab4 from './audio/Marimba.rubber.ff.Ab4.stereo.mp3';
import Ab5 from './audio/Marimba.rubber.ff.Ab5.stereo.mp3';
import Ab6 from './audio/Marimba.rubber.ff.Ab6.stereo.mp3';

// import B2 from './audio/Marimba.rubber.ff.B2.stereo.mp3';
import B3 from './audio/Marimba.rubber.ff.B3.stereo.mp3';
import B4 from './audio/Marimba.rubber.ff.B4.stereo.mp3';
import B5 from './audio/Marimba.rubber.ff.B5.stereo.mp3';
import B6 from './audio/Marimba.rubber.ff.B6.stereo.mp3';

// import Bb2 from './audio/Marimba.rubber.ff.Bb2.stereo.mp3';
import Bb3 from './audio/Marimba.rubber.ff.Bb3.stereo.mp3';
import Bb4 from './audio/Marimba.rubber.ff.Bb4.stereo.mp3';
import Bb5 from './audio/Marimba.rubber.ff.Bb5.stereo.mp3';
import Bb6 from './audio/Marimba.rubber.ff.Bb6.stereo.mp3';

// import C2 from './audio/Marimba.rubber.ff.C2.stereo.mp3';
import C3 from './audio/Marimba.rubber.ff.C3.stereo.mp3';
import C4 from './audio/Marimba.rubber.ff.C4.stereo.mp3';
import C5 from './audio/Marimba.rubber.ff.C5.stereo.mp3';
import C6 from './audio/Marimba.rubber.ff.C6.stereo.mp3';
import C7 from './audio/Marimba.rubber.ff.C7.stereo.mp3';

// import D2 from './audio/Marimba.rubber.ff.D2.stereo.mp3';
import D3 from './audio/Marimba.rubber.ff.D3.stereo.mp3';
import D4 from './audio/Marimba.rubber.ff.D4.stereo.mp3';
import D5 from './audio/Marimba.rubber.ff.D5.stereo.mp3';
import D6 from './audio/Marimba.rubber.ff.D6.stereo.mp3';

// import Db2 from './audio/Marimba.rubber.ff.Db2.stereo.mp3';
import Db3 from './audio/Marimba.rubber.ff.Db3.stereo.mp3';
import Db4 from './audio/Marimba.rubber.ff.Db4.stereo.mp3';
import Db5 from './audio/Marimba.rubber.ff.Db5.stereo.mp3';
import Db6 from './audio/Marimba.rubber.ff.Db6.stereo.mp3';

// import E2 from './audio/Marimba.rubber.ff.E2.stereo.mp3';
import E3 from './audio/Marimba.rubber.ff.E3.stereo.mp3';
import E4 from './audio/Marimba.rubber.ff.E4.stereo.mp3';
import E5 from './audio/Marimba.rubber.ff.E5.stereo.mp3';
import E6 from './audio/Marimba.rubber.ff.E6.stereo.mp3';

// import Eb2 from './audio/Marimba.rubber.ff.Eb2.stereo.mp3';
import Eb3 from './audio/Marimba.rubber.ff.Eb3.stereo.mp3';
import Eb4 from './audio/Marimba.rubber.ff.Eb4.stereo.mp3';
import Eb5 from './audio/Marimba.rubber.ff.Eb5.stereo.mp3';
import Eb6 from './audio/Marimba.rubber.ff.Eb6.stereo.mp3';

// import F2 from './audio/Marimba.rubber.ff.F2.stereo.mp3';
import F3 from './audio/Marimba.rubber.ff.F3.stereo.mp3';
import F4 from './audio/Marimba.rubber.ff.F4.stereo.mp3';
import F5 from './audio/Marimba.rubber.ff.F5.stereo.mp3';
import F6 from './audio/Marimba.rubber.ff.F6.stereo.mp3';

// import G2 from './audio/Marimba.rubber.ff.G2.stereo.mp3';
import G3 from './audio/Marimba.rubber.ff.G3.stereo.mp3';
import G4 from './audio/Marimba.rubber.ff.G4.stereo.mp3';
import G5 from './audio/Marimba.rubber.ff.G5.stereo.mp3';
import G6 from './audio/Marimba.rubber.ff.G6.stereo.mp3';

// import Gb2 from './audio/Marimba.rubber.ff.Gb2.stereo.mp3';
import Gb3 from './audio/Marimba.rubber.ff.Gb3.stereo.mp3';
import Gb4 from './audio/Marimba.rubber.ff.Gb4.stereo.mp3';
import Gb5 from './audio/Marimba.rubber.ff.Gb5.stereo.mp3';
import Gb6 from './audio/Marimba.rubber.ff.Gb6.stereo.mp3';

export {
  A3, A4, A5, A6,
  Ab3, Ab4, Ab5, Ab6,
  B3, B4, B5, B6,
  Bb3, Bb4, Bb5, Bb6,
  C3, C4, C5, C6, C7,
  D3, D4, D5, D6,
  Db3, Db4, Db5, Db6,
  E3, E4, E5, E6,
  Eb3, Eb4, Eb5, Eb6,
  F3, F4, F5, F6,
  G3, G4, G5, G6,
  Gb3, Gb4, Gb5, Gb6,
};



// WEBPACK FOOTER //
// ./src/stores/wrapper-mod.js